import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import AnnouncementBar from "@/components/AnnouncementBar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";
import MobileBottomNav from "@/components/MobileBottomNav";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import { GoldRatesPage, PlanPage } from "@/pages/RatesAndPlans";
import { Login, Register } from "@/pages/Auth";
import { Wishlist, Account } from "@/pages/Account";
import { Contact, CustomJewellery, About, Blog, NotFound } from "@/pages/Misc";
import Admin from "@/pages/Admin";
import MakingCharges from "@/pages/MakingCharges";

function Shell({ children }) {
    const loc = useLocation();
    const isAdmin = loc.pathname.startsWith("/admin");
    return (
        <>
            {!isAdmin && <AnnouncementBar />}
            {!isAdmin && <Header />}
            <main className="min-h-[60vh] pb-20 lg:pb-0">{children}</main>
            {!isAdmin && <Footer />}
            {!isAdmin && <FloatingWhatsapp />}
            {!isAdmin && <MobileBottomNav />}
        </>
    );
}

function AppRoutes() {
    return (
        <Shell>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Catalog />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/gold-jewellery" element={<Catalog presetCategory="gold" />} />
                <Route path="/silver-jewellery" element={<Catalog presetCategory="silver" />} />
                <Route path="/diamond-jewellery" element={<Catalog presetCategory="diamond" />} />
                <Route path="/bridal-jewellery" element={<Catalog presetCategory="bridal" />} />
                <Route path="/new-arrivals" element={<Catalog />} />
                <Route path="/gold-rates" element={<GoldRatesPage />} />
                <Route path="/silver-rates" element={<GoldRatesPage />} />
                <Route path="/gold-harvest" element={<PlanPage />} />
                <Route path="/kitty-plan" element={<PlanPage />} />
                <Route path="/custom-jewellery" element={<CustomJewellery />} />
                <Route path="/making-charges" element={<MakingCharges />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Shell>
    );
}

// Route-slug helper: /gold-harvest → slug=gold_harvest; /kitty-plan → slug=kitty
function PlanRouter() { return null; }

export default function App() {
    return (
        <BrowserRouter>
            <SettingsProvider>
                <AuthProvider>
                    <Toaster position="top-center" theme="light" richColors />
                    <AppRoutes />
                </AuthProvider>
            </SettingsProvider>
        </BrowserRouter>
    );
}
